export default {
  title: 'pro',
  self: 'self',
  isShowTitle: 'isShowTitle', // 是否显示标题
  isShowIntro: 'isShowIntro', // 是否显示简介
  buttonType: 'buttonType', // 按钮
  isShowSlide: 'isShowSlide', // 是否显示轮播图
  isShowThumb: 'isShowThumb', // 是否显示缩略图
  bigImgWidth: 'bigImgWidth', // 大图宽度
  thumbImgWidth: 'thumbImgWidth', // 缩略图宽度
  areaLength: 'areaLength', // 区域长度
  slideButtonColor: 'slideButtonColor', // 轮播图按钮颜色
  slideButtonHoverColor: 'slideButtonHoverColor', // 轮播图按钮hover颜色
  slideStyle: 'slideStyle', // 轮播图风格
  divOrder: 'divOrder',
  zoom: 'w-slide'
}

export const types = {
  one: 'product_intro_1',
  two: 'product_intro_2'
}

export const btnFlags = {
  inquireNow: 'inquire-now',
  nextProduct: 'next-product',
  downloadSingle: 'downloadSingle',
  addToCart: 'add-to-cart'
}
